import { Component, OnInit } from '@angular/core';
import {  Validators, FormControl } from '@angular/forms';
import { Router } from '@angular/router';
import { AuthService } from 'my-lib-sanfelici';



@Component({
  selector: 'app-reset-password',
  templateUrl: './reset-password.component.html',
  styleUrls: ['./reset-password.component.css']
})
export class ResetPasswordComponent implements OnInit {
email = new FormControl('', [Validators.required, Validators.email]);
  constructor(
    private router: Router,
    private authservice: AuthService
  ) {

  }

  ngOnInit() {
  }
  getErrorMessage() {
    return this.email.hasError('required') ? 'inserisci email' :
        this.email.hasError('email') ? 'email non valida' :'';
  }

  sendResetEmail() {
    this.authservice.resetPassword(this.email.value)
      .then(() => {
this.router.navigate(['auth', 'reset-conferma']);
      }).catch(err => {
console.log(err);
      });

  }
}
